import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { ArtSupportTeam } from 'sections/landing/SupportTeamArt';
import { SECTION_PY } from 'const/section';

// ==============================|| SUPPORT SECTION ||============================== //
//
// 料金の直後に置く「導入時の不安」への回答。
// FaqSection でも触れているが、料金を見た直後に出てくるのは
// 「使いこなせるか」「設定が大変ではないか」という懸念のため、
// サポートが無料であることと初期設定を任せられることをここで先に伝える。

const primaryColor = '#2aa1af';
const accentRed = '#e2574c';

const SupportSection = () => (
    <Box component="section" id="support" sx={{ py: SECTION_PY, bgcolor: '#fff', overflow: 'hidden' }}>
        <Container maxWidth="md">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.2 }}
            >
                <Box sx={{ textAlign: 'center' }}>
                    <Typography
                        variant="caption"
                        component="span"
                        sx={{ color: primaryColor, fontWeight: 900, letterSpacing: '0.2em', display: 'block', mb: 2 }}
                    >
                        SUPPORT
                    </Typography>
                    <Typography
                        variant="h2"
                        component="h2"
                        sx={{ fontWeight: 900, fontSize: { xs: '1.9rem', md: '2.6rem' }, color: '#1a1a1a', lineHeight: 1.4 }}
                    >
                        サポート体制
                    </Typography>
                    {/* 見出し直下の短い下線。セクションの切れ目を分かりやすくするための装飾 */}
                    <Box
                        aria-hidden="true"
                        sx={{ width: 56, height: 5, borderRadius: 3, bgcolor: primaryColor, mx: 'auto', mt: 2.5 }}
                    />
                </Box>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
            >
                {/* 線画は本文の補助なので小さく。見出しとリード文の間に置き、サポートの雰囲気だけを先に伝える */}
                <Box sx={{ maxWidth: { xs: 150, md: 180 }, mx: 'auto', mt: { xs: 3.5, md: 4 } }}>
                    <ArtSupportTeam />
                </Box>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
            >
                <Box sx={{ textAlign: 'center' }}>
                    <Typography
                        component="p"
                        sx={{
                            mt: { xs: 3, md: 3.5 },
                            color: '#374151',
                            fontSize: { xs: '1rem', md: '1.2rem' },
                            fontWeight: 700,
                            lineHeight: 2.1
                        }}
                    >
                        導入に向けて
                        <Box component="span" sx={{ color: accentRed }}>
                            専任の担当者
                        </Box>
                        が導入を支援します。
                        <Box component="br" />
                        <Box component="span" sx={{ color: accentRed }}>
                            サポート費用は無料
                        </Box>
                        なのでご安心ください。
                        <Box component="br" />
                        導入時に必要な事業所情報・利用者・職員データ等の
                        <Box component="br" sx={{ display: { xs: 'none', md: 'block' } }} />
                        初期設定もお任せください。
                    </Typography>
                </Box>
            </motion.div>
        </Container>
    </Box>
);

export default SupportSection;
